<!-- The home's palettes box for this one palette (owner 2026-10-15): app-palette-showcase without its
     palettes' dock, as a popover pointing at the clicked card like the themes page's expander. -->
<div [class.expander-panel]="!inline" [class.expander-inline]="inline" *ngIf="product"
     [style.--plugin-primary]="product.designTokens?.primaryColor"
     [style.--plugin-secondary]="product.designTokens?.secondaryColor">
  <app-palette-showcase [only]="entry" [siteDark]="darkModeActive">
    <!-- the box's edge round its popover shape (the clip drops its own), in the
         box's own edge colour -->
    <svg tsxOverlay class="expander-outline" *ngIf="!inline" aria-hidden="true"><path></path></svg>
  </app-palette-showcase>
</div>
